<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span v-if="convenio"
                        >CONVÊNIO -
                        <strong>{{ convenio.vcCodigoEstruturado }} </strong> -
                        EMISSÃO DE DOCUMENTOS</span
                    >
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONV-PAREC-FIN-00')"
                                :href="
                                    `#/convenios/${convenio.idConvenio}/parecerfinanceiro`
                                "
                                ><strong>Parecer Financeiro</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                :href="
                                    `#/convenios/${convenio.idConvenio}/oficioencerramento`
                                "
                                v-if="$temAcessoView('CONV-OFIC-ENC-00')"
                                ><strong>Ofício de Encerramento</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <app-btn-voltar></app-btn-voltar>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    props: {
        convenio: {
            type: Object
        }
    }
}
</script>
